import css from './index.module.css'

interface Props {
    availability: {
        state: 'green' | 'blue' | 'red'
        value: string
    }
    info: string
    price: number
    unit: string
}

export const PriceSeason = ({ availability, info, price, unit }: Props) => {
    return (
        <div className={`r-product-price-season ${css.container}`}>
            <div className={css.price}>
                <div className={css.quantity}>{price}</div>
                <div className={css.unit}>{unit}</div>
            </div>
            <div className={css.info}>{info}</div>
            <div className={`${css.availability} ${css[availability.state]}`}>{availability.value}</div>
        </div>
    )
}
